/* ============================================================
   NOBS & CO — Exit intent popup
   Desktop: cursor sai pelo topo da janela.
   Mobile: X segundos de inatividade (não dá pra detectar saída no touch).
   Aparece uma única vez por sessão; após fechar/assinar, respeita N dias.
   ============================================================ */
(function () {
  'use strict';

  var SESSION_KEY = 'nobs-ep-seen';
  var DISMISS_KEY = 'nobs-ep-dismissed-until';
  var SUBMIT_KEY = 'nobs-ep-submitting';

  function init() {
    var root = document.querySelector('[data-nobs-ep]');
    if (!root) return;

    var testMode = root.dataset.testMode === 'true';
    var minSeconds = parseInt(root.dataset.minSeconds, 10) || 5;
    var idleSeconds = parseInt(root.dataset.idleSeconds, 10) || 40;
    var dismissDays = parseInt(root.dataset.dismissDays, 10) || 7;

    /* Depois de enviar, a Shopify recarrega a página com ?customer_posted=true
       e o Liquid já renderiza a mensagem de sucesso dentro do popup — só falta
       reabrir. A flag de sessão garante que a gente só reabra quando o envio
       veio DESTE formulário (e não da newsletter do rodapé, por exemplo). */
    var justPosted = window.location.search.indexOf('customer_posted=true') !== -1;
    var wasOurs = false;
    try { wasOurs = sessionStorage.getItem(SUBMIT_KEY) === '1'; } catch (e) {}
    var openOnLoad = justPosted && wasOurs;
    if (openOnLoad) {
      try { sessionStorage.removeItem(SUBMIT_KEY); } catch (e) {}
    }

    /* marca que o envio partiu daqui, antes do reload */
    var epForm = root.querySelector('form');
    if (epForm) {
      epForm.addEventListener('submit', function () {
        try { sessionStorage.setItem(SUBMIT_KEY, '1'); } catch (e) {}
      });
    }

    var shown = false;
    var armed = false;
    var idleTimer = null;

    function canShow() {
      if (testMode) return true;
      try {
        if (sessionStorage.getItem(SESSION_KEY)) return false;
        var until = localStorage.getItem(DISMISS_KEY);
        if (until && Date.now() < parseInt(until, 10)) return false;
      } catch (e) { /* storage bloqueado — segue */ }
      return true;
    }

    function markSeen() {
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    }

    function markDismissed() {
      try {
        localStorage.setItem(DISMISS_KEY, String(Date.now() + dismissDays * 86400000));
      } catch (e) {}
    }

    function show() {
      if (shown || !canShow()) return;
      shown = true;
      markSeen();
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      teardown();
    }

    function hide(dismiss) {
      root.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (dismiss) markDismissed();
      setTimeout(function () { root.hidden = true; }, 300);
    }

    /* ---------- gatilho desktop: cursor sai pelo topo ---------- */
    function onMouseOut(e) {
      if (!armed) return;
      if (e.relatedTarget || e.toElement) return; // ainda dentro da página
      if (e.clientY > 0) return;                  // saiu pelos lados/baixo
      show();
    }

    /* ---------- gatilho mobile: inatividade ---------- */
    function resetIdle() {
      if (!armed) return;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(show, idleSeconds * 1000);
    }

    function teardown() {
      document.removeEventListener('mouseout', onMouseOut);
      clearTimeout(idleTimer);
      ['scroll', 'touchstart', 'click', 'keydown'].forEach(function (ev) {
        window.removeEventListener(ev, resetIdle);
      });
    }

    /* ---------- fechar ---------- */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-nobs-ep-close]')) {
        e.preventDefault();
        hide(true);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) hide(true);
    });

    /* ---------- arma os gatilhos ---------- */
    if (openOnLoad) {
      // voltou do envio do formulário: mostra o estado de sucesso
      shown = true;
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      markSeen();
      markDismissed();
      return;
    }

    if (!canShow()) return;

    setTimeout(function () {
      armed = true;
      var isTouch = window.matchMedia('(pointer: coarse)').matches;
      if (isTouch) {
        ['scroll', 'touchstart', 'click', 'keydown'].forEach(function (ev) {
          window.addEventListener(ev, resetIdle, { passive: true });
        });
        resetIdle();
      } else {
        document.addEventListener('mouseout', onMouseOut);
      }
    }, minSeconds * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
